<section class="bd-masthead">
    <div class="px-4 px-md-3 container">
        <div class="row align-items-lg-center">
            <div class="col-lg-5 col-md-4 order-md-1">
                <img class="img-fluid" src="../../../../assets/img/contact.svg" alt="Contact Illustration">
            </div>
            <div class="col-md-7 mx-auto order-md-2 col-lg-7 text-center text-md-start">
                <div class="title">
                    <h1 class="fw-bold fs-2 text-black">Contact Us</h1>
                </div>

                <div class="py-4">
                     <h2 class="fs-4 mb-2 text-black">
                        Have questions or need support? We're here to help.</h2>

                        <p class="txt-description mb-5 text-secondary">
                      Whether it’s about your subscription, billing, licensing, or custom illustration requests our team is ready to assist.
                      
                    </p>

                    <h2 class="txt-title fs-4 mb-4 text-black">General Support</h2>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                          <strong>Email:</strong> <a class="un-link bold"
                                href="mailto:support@illusbook.com">support&#64;illusbook.com</a>
                        </li>
                        <li class="mb-3">
                        <strong>Support Hours:</strong> Monday to Friday, 10:00 AM – 6:00 PM (IST).
                        </li>
                        <li class="mb-3">
                        We usually respond within 24–48 hours.
                        </li>
                    </ul>

                      <h2 class="txt-title fs-4 mb-4 text-black">Mailing Address</h2>
                        <strong class="bold">Goodsketches</strong>, <br>
                        135, Greenfield's Crown City, Phase II, Sathy Main Road, Kovilpalayam, <br>
                        Coimbatore - 641107 Tamil Nadu,<br>
                        India.
                </div>
            </div>
        </div>
    </div>
</section>